<script setup>
    import { ref, watchEffect, watch } from 'vue'
    import { TextareaField } from '@/js/components/Common'
    import { parseKommaToFloat } from '@/js/utils'

    const props = defineProps({
        lehrformen: {
            type: Array,
            required: true
        }
    })
    const emit = defineEmits(['update:lehrformen'])

    const newLehrform = ref({
        lehrformName: '',
        kontaktzeit: '',
        selbststudium: '',
        gesamt: ''
    })

    const resetNewLehrform = () => {
        newLehrform.value = {
            lehrformName: '',
            kontaktzeit: '',
            selbststudium: '',
            gesamt: ''
        }
    }

    const validateName = (value) => value !== '' || 'Name darf nicht leer sein'
    const validateKontaktzeit = (lehrform) => true
    const validateSelbststudium = (lehrform) => true

    const validateGesamt = (value) => {
        const gesamt = parseKommaToFloat(value)
        return (gesamt !== '' && !isNaN(gesamt)) || 'Muss eine gültige Zahl sein'
    }

    const validateLehrform = (lehrform) => {
        return (
            validateName(lehrform.lehrformName) === true &&
            validateKontaktzeit(lehrform.kontaktzeit) === true &&
            validateSelbststudium(lehrform.selbststudium) === true &&
            validateGesamt(lehrform.gesamt) === true
        )
    }

    const saveNewLehrform = () => {
        if (validateLehrform(newLehrform.value)) {
            emit('update:lehrformen', [...props.lehrformen, newLehrform.value])
            resetNewLehrform()
        }
    }

    const deleteLehrFormRow = (index) => {
        const lehrformen = [...props.lehrformen]
        lehrformen.splice(index, 1)
        emit('update:lehrformen', lehrformen)
    }

    watchEffect(() => {})
</script>

<template>
    <div
        v-for="(lehrForm, index) in props.lehrformen"
        :key="index"
        class="d-flex w-100 flex-nowrap align-stretch text-grey"
    >
        <textarea-field v-model="lehrForm.lehrformName" :rules="[validateName]" rows="2" />
        <textarea-field v-model="lehrForm.kontaktzeit" rows="2" />
        <textarea-field v-model="lehrForm.selbststudium" rows="2" />
        <textarea-field v-model="lehrForm.gesamt" :rules="[validateGesamt]" rows="2" />
        <v-btn
            :id="`remove-row-button-${index}`"
            icon="mdi-trash-can"
            title="Lehrform entfernen"
            border
            height="inherit"
            class="border-primary text-grey"
            color="primary-lighten-2"
            tile
            variant="flat"
            @click="deleteLehrFormRow(index)"
        />
    </div>
    <div class="mt-2 text-grey">
        <label>Neue Lernform:</label>
        <div class="d-flex flew-nowrap mt-1">
            <v-textarea
                v-model="newLehrform.lehrformName"
                label="Lernform"
                :rules="[validateName]"
                variant="outlined"
                hideDetail
                rows="1"
            />
            <!--            :state="validateName(newLehrform)"-->
            <v-textarea v-model="newLehrform.kontaktzeit" label="Kontaktzeit" variant="outlined" hide-detail rows="1" />
            <!--            :state="validateKontaktzeit(newLehrform)"-->
            <v-textarea
                v-model="newLehrform.selbststudium"
                label="Selbststudium"
                variant="outlined"
                hide-detail
                rows="1"
            />
            <!--            :state="validateSelbststudium(newLehrform)"-->
            <v-textarea
                v-model="newLehrform.gesamt"
                label="Gesamt"
                :rules="[validateGesamt]"
                variant="outlined"
                hide-detail
                rows="1"
            />
            <!--            :state="validateGesamt(newLehrform)"-->
            <v-btn
                border
                class="border-primary text-grey"
                color="primary-lighten-2"
                tile
                variant="flat"
                icon="mdi-check"
                title="Lernform übernehmen"
                :disabled="!validateLehrform(newLehrform)"
                @click="saveNewLehrform"
            />
        </div>
    </div>
</template>

<script></script>

<style scoped lang="scss">
    label {
        margin-bottom: 0 !important;
    }

    .input-entry-show {
        white-space: pre-line;
    }

    // autoheight for textareas will render an empty scrollbar
    // this will hide it
    textarea {
        overflow-y: hidden !important;
    }
</style>
